import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <aside
      className={`
        fixed inset-y-0 left-0 z-30 w-64 transition-all duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
    >
      <div className="h-full px-3 py-4 overflow-y-auto bg-olive-700">
        <button onClick={toggleSidebar} className="absolute top-4 right-4 text-white md:hidden">
          <X size={24} />
        </button>
        <ul className="space-y-2 font-medium mt-8">
          <li>
            <Link to="/" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/milestones" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              My Milestones
            </Link>
          </li>
          <li>
            <Link to="/memories" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              My Memories
            </Link>
          </li>
          <li>
            <Link to="/family-tree" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              Family Tree
            </Link>
          </li>
          <li>
            <Link to="/family-manager" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              My Family
            </Link>
          </li>
          <li>
            <Link to="/stories" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              Stories
            </Link>
          </li>
          <li>
            <Link to="/photos" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              Photos
            </Link>
          </li>
          <li>
            <Link to="/recipes" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              Recipes
            </Link>
          </li>
          <li>
            <Link to="/settings" className="flex items-center p-2 text-white rounded-lg hover:bg-olive-600">
              Settings
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;